// Main store to store constants and other common stuff
import { uniqBy } from 'lodash-es'

const state = {
  lastViewedGateways: [],
  lastViewedEndDevices: [],
  lastViewedMulticastGroups: []
}

export const getters = {
  lastViewedGateways: state => state.lastViewedGateways,
  lastViewedEndDevices: state => state.lastViewedEndDevices,
  lastViewedMulticastGroups: state => state.lastViewedMulticastGroups
}

export const mutations = {
  resetLastViewedLists (state) {
    state.lastViewedGateways = []
    state.lastViewedEndDevices = []
    state.lastViewedMulticastGroups = []
  },

  addLastViewedGateway (state, gateway) {
    const lastViewedGateways = state.lastViewedGateways
    lastViewedGateways.unshift({
      id: gateway.eui,
      name: gateway.name,
      route: { name: 'gatewayRoute', params: { eui: gateway.eui } }
    })
    state.lastViewedGateways = uniqBy(lastViewedGateways, 'id').slice(0, 6)
  },

  addLastViewedEndDevice (state, endDevice) {
    const lastViewedEndDevices = state.lastViewedEndDevices
    lastViewedEndDevices.unshift({
      id: endDevice.devEui,
      name: endDevice.name,
      route: { name: 'endDevice', params: { devEui: endDevice.devEui } }
    })
    state.lastViewedEndDevices = uniqBy(lastViewedEndDevices, 'id').slice(0, 6)
  },

  addLastViewedMulticastGroup (state, multicastGroup) {
    const lastViewedMulticastGroups = state.lastViewedMulticastGroups
    lastViewedMulticastGroups.unshift({
      id: multicastGroup.id,
      name: multicastGroup.name,
      route: { name: 'multicastGroup', params: { id: multicastGroup.id } }
    })
    state.lastViewedMulticastGroups = uniqBy(lastViewedMulticastGroups, 'id').slice(0, 6)
  }
}

export default {
  state,
  getters,
  mutations
}
